import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatProgressSpinner} from '@angular/material/progress-spinner';
import { MatDialog } from '@angular/material/dialog';
import { AlertifyService } from 'src/app/services/alertify.service';
import { DisciplinaService } from 'src/app/services/disciplina.service';
import { ingresoAdminLst } from 'src/app/models/ingresoLst';
import { ReporteService } from 'src/app/services/reporte.service';
import { ListaCodigoNoIngreso } from 'src/app/models/LISTAS';
import {
  MomentDateAdapter,
  MAT_MOMENT_DATE_ADAPTER_OPTIONS,
} from '@angular/material-moment-adapter';
import {
  DateAdapter,
  MAT_DATE_FORMATS,
  MAT_DATE_LOCALE,
} from '@angular/material/core';

import * as _moment from 'moment';
// tslint:disable-next-line:no-duplicate-imports
import { default as _rollupMoment, Moment } from 'moment';
import { EmpresaService } from 'src/app/services/empresa.service';
import { SeleccionFechaReporteExcelComponent } from './seleccion-fecha-reporte-excel/seleccion-fecha-reporte-excel.component';

const moment = _rollupMoment || _moment;

export const MY_FORMATS = {
  parse: {
    dateInput: 'DD/MM/YYYY',
  },
  display: {
    dateInput: 'DD/MM/YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

@Component({
  selector: 'app-ingresos-fechas-admin',
  templateUrl: './ingresos-fechas-admin.component.html',
  styleUrls: ['./ingresos-fechas-admin.component.scss'],
  providers: [{ provide: MAT_DATE_FORMATS, useValue: MY_FORMATS }],
})
export class IngresosFechasAdminComponent implements OnInit {
  public dataSource: any;
  public displayedColumns: string[];
  public isLoadingResults = false;
  // pageEvent: PageEvent;
  pageIndex: number = 0;
  pageSize: number = 10;
  length: number;
  searchString: string = '';
  public lstDisciplinas: any;
  public disciplinaSelect: any;
  startDate: any;
  endDate: any;
  public lstClubes: any;
  public clubSelect: any;

  @ViewChild(MatPaginator) paginator: MatPaginator;

  constructor(
    public reporteSvc: ReporteService,
    public empresaSvc: EmpresaService,
    public disciplinaSvc: DisciplinaService,
    public dialog: MatDialog,
    private alertify: AlertifyService
  ) {
    let ELEMENT_DATA: any[] = [];
    this.displayedColumns = [
      'nombre',
      'empresa',
      'disciplina',
      'fecha',
      'resultado',
    ];

    this.dataSource = new MatTableDataSource<any>(ELEMENT_DATA);
  }
  ngAfterViewInit() {
    this.disciplinaSvc.getDisciplinasDropdown().subscribe((disLst) => {
      console.log(disLst);
      this.lstDisciplinas = disLst;
    });

    this.empresaSvc.getEmpresasDropdown().subscribe((clubLst) => {
      console.log(clubLst);
      this.lstClubes = clubLst;
    });

    this.dataSource.paginator = this.paginator;
  }

  ngOnInit(): void {}

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  getIngresos(page: number, numReg: number) {
    this.isLoadingResults = true;
    this.reporteSvc
      .getIngresosFechasAdmin(
        page,
        numReg,
        this.searchString,
        this.startDate.format('YYYY-MM-DDTHH:mm:ss'),
        this.endDate.format('YYYY-MM-DDTHH:mm:ss'),
        this.disciplinaSelect,
        this.clubSelect,
      )
      .subscribe((result) => {
        this.dataSource = new MatTableDataSource<ingresoAdminLst>(result[0]);
        this.pageIndex = page;
        this.pageSize = numReg;
        this.length = result[1];
        this.isLoadingResults = false;
        console.log('resultado: ', result);
      });
  }

  getServerData(event: PageEvent) {
    console.log('click evento paginator', event);
    this.getIngresos(event.pageIndex, event.pageSize);
  }

  buscar() {
    if (this.startDate == null) {
      this.alertify.error('El periodo de busqueda no es valido (fecha desde)');
      return;
    }
    if (this.endDate == null) {
      this.alertify.error('El periodo de busqueda no es valido (fecha hasta)');
      return;
    }
    console.log(this.startDate.toDate());
    console.log(this.endDate.toDate());
    console.log(this.disciplinaSelect);

    this.getIngresos(0, 10);
  }

  getTextoCodigoNoIngreso(codigo: number): string {
    return ListaCodigoNoIngreso.find((x) => x.codigo == codigo)?.texto || '';
  }


  descargarReporte() {
    let dialogRef = this.dialog.open(SeleccionFechaReporteExcelComponent, {
    //  data: usr,
    });
/* 

    this.reporteSvc.getReporteIngresosPorFecha('2024-01-10').subscribe((result) => {
      console.log('result: ', result);
      let blob = new Blob([result], { type: 'application/vnd.ms-excel' });
      var downloadURL = window.URL.createObjectURL(result);
      var link = document.createElement('a');
      link.href = downloadURL;
      link.download =  'reporteIngresos' + '.xlsx';
      link.click();
    }); */

//SeleccionFechaReporteExcelComponent


  }





}
